<h2 mat-dialog-title>{{isEditMode ? 'Döküman Düzenle' : 'Yeni Döküman Ekle'}}</h2>

<mat-dialog-content>
    <form [formGroup]="documentForm" class="document-form">
        <!-- Döküman Tipi Seçimi -->
        <div class="row mb-3">
            <div class="col-12">
                <mat-label class="mb-2 d-block">Döküman Tipi</mat-label>
                <mat-radio-group formControlName="documentType" [disabled]="isEditMode">
                    <mat-radio-button value="folder" style="margin-right: 14px">Klasör</mat-radio-button>
                    <mat-radio-button value="file">Evrak</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>

        <!-- Kod ve Açıklama -->
        <div class="row mb-3">
            <div class="col-md-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Ad</mat-label>
                    <input matInput formControlName="name" placeholder="GK-01">
                </mat-form-field>
            </div>
            <div class="col-md-8">
                <mat-form-field appearance="outline" class="w-100"
                    *ngIf="documentForm.get('documentType').value === 'file'">
                    <mat-label>Açıklama</mat-label>
                    <input matInput formControlName="description">
                </mat-form-field>
            </div>
        </div>

        <!-- Klasör Seçimi (Sadece Evrak seçiliyse görünür) -->
        <div class="row mb-3">
            <div class="col-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Klasör Seç</mat-label>
                    <mat-select formControlName="parentFolder">
                        <div class="select-search-field">
                            <mat-form-field class="w-100">
                                <input matInput type="text" [formControl]="folderFilterCtrl" placeholder="Ara..."
                                    (keyup)="filterFolders()">
                            </mat-form-field>
                        </div>
                        <mat-option *ngFor="let folder of filteredFolders" [value]="folder">
                            {{folder.path}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="documentForm.get('parentFolder').errors?.required || 
                      documentForm.get('parentFolder').errors?.invalidFolder">
                        Lütfen bir klasör seçiniz
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Sıra No</mat-label>
                    <input matInput type="number" formControlName="orderSeq" min="0" max="1000">
                    <mat-error *ngIf="documentForm.get('orderSeq').errors?.required">
                        Sıra no gereklidir
                    </mat-error>
                    <mat-error *ngIf="documentForm.get('orderSeq').errors?.max">
                        Sıra no maksimum 1000 olabilir
                    </mat-error>
                    <mat-error *ngIf="documentForm.get('orderSeq').errors?.min">
                        Sıra no minimum 0 olabilir
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <!-- Dosya Yükleme (Sadece Evrak seçiliyse görünür) -->
        <div class="row" *ngIf="documentForm.get('documentType').value === 'file'">
            <div class="col-12">
                <div class="file-upload-container">
                    <input type="file" #fileInput hidden (change)="onFileSelected($event)">
                    <button mat-stroked-button type="button" (click)="fileInput.click()" class="w-100 upload-button">
                        <mat-icon>attach_file</mat-icon>
                        <span>{{isEditMode ? 'Dosyayı Değiştir' : 'Dosya Seç'}}</span>
                    </button>
                    <div class="selected-file mt-2" *ngIf="selectedFileName">
                        <mat-icon>insert_drive_file</mat-icon>
                        <span>{{ selectedFileName }}</span>
                    </div>
                </div>
            </div>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">İptal</button>
    <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="documentForm.invalid || 
                      (documentForm.get('documentType').value === 'file' && 
                       (documentForm.get('parentFolder').hasError('invalidFolder') || 
                        documentForm.get('parentFolder').hasError('required')))">
        {{isEditMode ? 'Güncelle' : 'Kaydet'}}
    </button>
</mat-dialog-actions>